import { ColocaNetworkIcon } from "@/shared/components/data-display/ColocaCryptoIcon";
import { cn } from "@/shared/lib/utils";

import { useCryptoSwapLabels } from "../../hooks/useCryptoSwapLabels";

export { ColocaNetworkIcon as NetworkIcon };

export interface NetworkNameProps {
  network: string;
  /** The full label ("BNB Smart Chain (BEP-20)") instead of the short one. */
  full?: boolean;
  size?: number;
  className?: string;
}

/** The network as people recognise it: its mark next to its name. */
export function NetworkName({ network, full = false, size = 16, className }: NetworkNameProps) {
  const labels = useCryptoSwapLabels();
  const name = full ? labels.network(network) : labels.networkShort(network);
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      <ColocaNetworkIcon network={network} size={size} />
      <span>{name || "—"}</span>
    </span>
  );
}
